/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

class Curriculum{
    constructor(uid , packageID , translationID){
        this.uid = uid;
        this.translationID = translationID;
    }

    getID(){
        return this.uid;
    }

    getImage(){
        return 'img/logos/languagenut/no-text-logo.png'
    }

    getName(){
        return <FormattedMessage id={ "module-"+this.translationID } defaultMessage={ " " } values={{index:" "}} />
    }

    getPackage(){
        return this.packageID;
    }
}

export default Curriculum;


// WEBPACK FOOTER //
// ./src/classes/curriculum.js